<template>
    <div class="d-flex flex-column justify-content-start m-1">
        <small class="flex-grow-0 text-secondary">{{ filter.title }}</small>
        <div class="flex-grow-1">
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap">
                <b-form-datepicker
                    :ref="filterNameFrom"
                    v-model="dateFrom"
                    :locale="'ru'"
                    :label-no-date-selected="'От'"
                    :label-help="''"
                    :reset-button="true"
                    :label-reset-button="'Сбросить'"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    @input="onFilterFromChanged">
                </b-form-datepicker>
                <span class="ml-1 mr-1 text-secondary">&nbsp;—&nbsp;</span>
                <b-form-datepicker
                    :ref="filterNameTo"
                    v-model="dateTo"
                    :locale="'ru'"
                    :label-no-date-selected="'До'"
                    :label-help="''"
                    :reset-button="true"
                    :label-reset-button="'Сбросить'"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    @input="onFilterToChanged" >
                </b-form-datepicker>
            </div>
        </div>
    </div>
</template>

<script>
    import { DateSubmitProcessor } from "@/utils/dateFormat";

    export default {
        name: "DataTableDateFilter",
        props: {
            filter: { type: Object, default: () => { return {} } },
            initialValueFrom: { type: Object, default: () => { return {} } },
            initialValueTo: { type: Object, default: () => { return {} } }
        },
        data() {
            return {
                dateFrom: null,
                dateTo: null,
            }
        },
        computed: {
            filterNameFrom() {
                return `${this.filter.name}_from`;
            },
            filterNameTo() {
                return `${this.filter.name}_to`
            }
        },
        methods: {
            reset() {
                this.dateFrom = null;
                this.dateTo = null;
            },
            resetValue(value) {
                this.dateFrom = null;
                this.dateTo = null;
            },
            resetChildValue(value, name) {
                if (name === this.filterNameTo) {
                    this.dateTo = null;
                }
                if (name === this.filterNameFrom) {
                    this.dateFrom = null;
                }
            },
            onFilterFromChanged() {
                this.$emit('filter-removed', this.filterNameFrom);
                if (this.dateFrom) {
                    let localDateFrom = DateSubmitProcessor.convertDateToLocal(this.dateFrom);
                    const label = `${this.filter.title} не ранее ${localDateFrom}`;
                    this.$emit('filter-added', this.filterNameFrom, localDateFrom, label, this.filter.name);
                }
            },
            onFilterToChanged() {
                this.$emit('filter-removed', this.filterNameTo);
                if (this.dateTo) {
                    let localDateTo = DateSubmitProcessor.convertDateToLocal(this.dateTo);
                    const label = `${this.filter.title} не позднее ${localDateTo}`;
                    this.$emit('filter-added', this.filterNameTo, localDateTo, label, this.filter.name);
                }

            },
        },
        mounted() {
            if (this.initialValueFrom && this.initialValueFrom['value']) {
                this.dateFrom = DateSubmitProcessor.convertDateToNative(this.initialValueFrom['value'])
            }
            if (this.initialValueTo && this.initialValueTo['value']) {
                this.dateTo = DateSubmitProcessor.convertDateToNative(this.initialValueTo['value'])
            }
        }
    }
</script>

<style scoped>

</style>